const ConfigDB = {
  settings: {
    layout_type: "ltr",
    layout_class: "compact-wrapper",
    sidebar: {
      type: "compact-wrapper",
      iconType: "stroke-icon",
    },
    sidebar_setting: "default-sidebar",
  },
  color: {
    primary_color: "#1a5f7f",
    secondary_color: "#dd7031",
    mix_background_layout: "light-only",
  },
  router_animation: "fadeIn",
};

export default ConfigDB;
